import AxiosPermisos  from './../axiosPermisos'

import { path } from './path'

import {
  map_query
} from "@/core/functions/map-path-query";

async function getManagerBlocks (data = {}) {
  const url = path.managerBlocks.concat(map_query(data))
  return await AxiosPermisos.get(url, true, 'v2')
}

async function forgetManagerBlock (id = '')  {
  return await AxiosPermisos.delete(`${path.forgetBlock}${id}`, true, 'v2')
}

export {
  getManagerBlocks,
  forgetManagerBlock
}